export default __webpack_public_path__ + "static/media/vietnam-circle-flag.ad2da95c.png";